import * as $ from 'jquery'
import './site_common'
import ScrollHint from 'scroll-hint'

import 'Components/site/subsidies/company_card/component'
import 'Components/site/call_to_action_link/component'
import 'Components/basics/breadcrumb/component'

import 'Components/site/subsidies/go_to_top/component'
import 'Components/site/subsidies/heading/component'
import 'Components/site/subsidies/heading_from_brackets_to_underline/component'
import 'Components/site/subsidies/accordion_content_with_heading/component'
import 'Components/site/subsidies/terms_section/component'
import 'Components/site/subsidies/receiving_flow_section/component'
import 'Components/site/subsidies/search_by_prefectures/component'
import 'Components/site/subsidies/search_by_construction_type/component'
import 'Components/site/subsidies/detail_card/component'
import 'Components/site/subsidies/summary_card/component'
import 'Components/site/subsidies/call_to_action_side_banner/component'

import { setViewHeight } from '../src/subsidies/components/setViewHeight'

window.$ = $

$(() => {
  // スマホのメニューバーを考慮したvhを利用するために実行
  setViewHeight()
  window.addEventListener('resize', setViewHeight)

  // スマホ時のスクロールヒント表示
  new ScrollHint('.js-scrollHint-target', { i18n: { scrollable: '横スクロール' } })
})
